import auth from '../../services/auth'

export default {

  data() {
    return {
      taxIdNumber: undefined,

      formState: 'NEW',
      loading: false,
      validTaxIdNumber: false,
    }
  },

  computed: {
    type() {
      return this.$route.params.type;
    }
  },

  created(){
    this.taxIdNumber = this.$route.query.taxIdNumber;
  },

  methods: {
    doRequest() {
      const hash = window.location.hash;
      auth.saveHash(hash);

      this.formState = 'NEW';
      this.$validator.validateAll()
        .then(success => {
          console.log(this.taxIdNumber);
          auth.saveTaxIdNumber(this.taxIdNumber);
          this.$router.push({
            name: 'auth-email-tel-req'
          });
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/auth-email-cnpj-req.js